///<reference path='../../typings/index.d.ts' />
///<reference path='../config.ts' />
///<reference path='../manifest/assets.ts' />
///<reference path='../menu.ts' />

module agi.expressions.card.controller {
    import EventBus       = agi.expressions.event.EventBus;
    import Event          = agi.expressions.event.Event;
    import AssetsManifest = agi.expressions.card.manifest.AssetManifest;
    import Menu = agi.expressions.card.Menu;

    export class PIXIMenuController {
        protected assetManifest:AssetsManifest; 
        protected eventBus:EventBus = EventBus.getInstance();
        protected renderer:PIXI.CanvasRenderer|PIXI.WebGLRenderer;
        protected menu:Menu = undefined;
        protected loader:HTMLElement;

        constructor (
            assets:AssetsManifest, 
            renderer:PIXI.CanvasRenderer|PIXI.WebGLRenderer
        ){

            this.assetManifest = assets;
            this.renderer = renderer; 
        }

        public init(pixiContainer:PIXI.Container){
            this.menu = new Menu(
                this.assetManifest, 
                this.onButtonDown.bind(this), 
                this.onButtonUp.bind(this)
            );
            this.menu.position.x = this.renderer.width - this.menu.width;
            this.menu.position.y = 10;
            pixiContainer.addChild(this.menu);
        }

        public showSend() {
            this.menu.showSend();
        }

        public createLoaderDiv(container:HTMLElement):void {
            var wrapper = document.createElement('div');
            wrapper.style.width = "100px";
            wrapper.style.padding = "10px";
            wrapper.style.position = "absolute";
            wrapper.style.left = ((window.innerWidth / 2) - 70) + "px";
            wrapper.style.top = ((window.innerHeight / 2) - 70) + "px";
            wrapper.style.borderRadius = "10px";
            wrapper.style.webkitBorderRadius = "10px";
            wrapper.style.background = "rgba(255,255,255,1.0)";
            wrapper.style.display = "none";
            var image = document.createElement('img');
            image.src = this.assetManifest.loaderGIF;
            wrapper.appendChild(image);
            this.loader = wrapper;
            container.appendChild(wrapper);
        }


        //Menu Events
        protected onButtonDown(ev:PIXI.interaction.InteractionEvent):void{
            if(!this.menu.animating && this.loader.style.display === "none"){
                if(ev.target === this.menu.replayButton){
                    var replayButtonEvent:Event = new Event("replay", this);
                    this.eventBus.dispatchEvent(replayButtonEvent);
                    this.menu.closeMenu();
                } else if (ev.target === this.menu.openButton){
                    this.menu.openMenu();
                } else if (ev.target === this.menu.closeButton){
                    this.menu.closeMenu();
                } else if (ev.target === this.menu.fullscreenCloseButton){
                    this.handleCloseButton(null);
                } else if (ev.target === this.menu.muteButton){
                    this.handlePauseMusic(null);
                } else if (ev.target === this.menu.unMuteButton){
                    this.handlePlayMusic(null);
                } else if (ev.target === this.menu.sendButton){
                    this.handleSendButton(null);
                }
            }
        }

        protected onButtonUp(ev:PIXI.interaction.InteractionEvent):void{
        }

        protected handleCloseButton(event:any){
            this.menu.closeMenu();
            var closeButtonEvent:Event = new Event("closeButton", this);
            this.eventBus.dispatchEvent(closeButtonEvent);
        }

        protected handlePauseMusic(event:any){
            this.menu.toggleMute();
            var pauseMusicEvent:Event = new Event("pauseMusic", this);
            this.eventBus.dispatchEvent(pauseMusicEvent);
        }

        protected handlePlayMusic(event:any){
            this.menu.toggleMute();
            var playMusicEvent:Event = new Event("playMusic", this);
            this.eventBus.dispatchEvent(playMusicEvent);
        }

        protected handleSendButton(event:any){
            this.loader.style.left = ((window.innerWidth / 2) - 70) + "px";
            this.loader.style.top = ((window.innerHeight / 2) - 70) + "px";
            this.loader.style.display = "inline-block";
            var sendButtonEvent:Event = new Event("send", this);
            this.eventBus.dispatchEvent(sendButtonEvent);
        }
    }
}